import { useAcceptCashAgreementsMutation } from '@twisto/api-graphql'

import { ContractDocuments } from '../../components'
import { useFlow } from '../../flow/flow.context'

import * as styles from './cash-agreements-step.styles'

export const CashAgreementsStep = () => {
  const { sessionId, flow } = useFlow<'CashAgreementsStep'>()
  const [acceptContract, { loading }] = useAcceptCashAgreementsMutation()

  const currentStepData = flow.currentStep

  const handleSubmit = () => {
    acceptContract({
      variables: {
        auth: {
          sessionId,
        },
      },
    })
  }

  return (
    <div css={styles.root}>
      <ContractDocuments
        documents={currentStepData.documents}
        loading={loading}
        onSubmit={handleSubmit}
      />
    </div>
  )
}
